


// // import React from "react";
// // import { useParams } from "react-router-dom";
// // import blogDataTr from "../data/blog-post.json";
// // import Footer from "../components/Footer";

// // import HeroSlider from "../components/HeroSlider";
// // import { Badge } from "lucide-react";
// // import BadgeSection from "../components/BadgeSection";
// // import AboutSection from "../components/AboutSection";


// // const BlogDetail = () => {
// //   const { slug } = useParams();
// //   const blogData = blogDataTr["blog-post"];
// //   const post = blogData.find((p) => p.slug === slug);

// //   if (!post) {
// //     return (
// //       <div className="text-center text-red-500 py-20">
// //         Blog bulunamadı
// //       </div>
// //     );
// //   }

// //   return (
// //     <>
// //       <HeroSlider />
      
// //       <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
// //         {/* Sol Yan: Hizmetler + Popüler Sorular */}
// //         <aside className="space-y-6">
       
// //         </aside>

// //         {/* Ana İçerik */}
// //         <main className="lg:col-span-2">
// //           <h1 className="text-3xl font-bold mb-6 text-black">{post.title}</h1>

// //           {post.sections.map((section, index) => (
// //             <div key={index} className="mb-10">
// //               {section.heading && (
// //                 <h2 className="text-2xl font-semibold mb-3 text-gray-800">
// //                   {section.heading}
// //                 </h2>
// //               )}

// //               {section.paragraphs && (
// //                 <div className="space-y-4 text-gray-800 leading-relaxed">
// //                   {section.paragraphs.map((para, idx) => (
// //                     <p key={idx}>{para}</p>
// //                   ))}
// //                 </div>
// //               )}

// //               {section.bulletPoints && (
// //                 <ul className="list-disc list-inside space-y-2 text-gray-800 mt-4">
// //                   {section.bulletPoints.map((item, i) => (
// //                     <li key={i}>{item}</li>
// //                   ))}
// //                 </ul>
// //               )}
// //             </div>
// //           ))}
// //         </main>

// //         {/* Sağ Yan: İletişim ve Kampanya */}
        
// //       </div>
// //         {/* <BadgeSection /> */}
// //         <AboutSection/>
// //       <Footer />
// //     </>
// //   );
// // };

// // export default BlogDetail;
// import React from "react";
// import { useParams } from "react-router-dom";
// import blogDataTr from "../data/blog-post.json";
// import Footer from "../components/Footer";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";

// // Yeni eklediğimiz yan bileşenler
// import LeftSidebar from "../components/Sidebars/LeftSidebar";
// import RightSidebar from "../components/Sidebars/RightSidebar";

// const BlogDetail = () => {
//   const { slug } = useParams();
//   const blogData = blogDataTr["blog-post"];
//   const post = blogData.find((p) => p.slug === slug);

//   if (!post) {
//     return (
//       <div className="text-center text-red-500 py-20">
//         Blog bulunamadı
//       </div>
//     );
//   }

//   return (
//     <>
//       <HeroSlider />

//       <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
//         {/* Sol Yan: Görsel ve özellik listesi */}
//          <div className="w-full">
//           <LeftSidebar />
//         </div>

//         {/* Ana İçerik */}
//         <main className="lg:col-span-2">
//           <h1 className="text-3xl font-bold mb-6 text-black">{post.title}</h1>

//           {post.sections.map((section, index) => (
//             <div key={index} className="mb-10">
//               {section.heading && (
//                 <h2 className="text-2xl font-semibold mb-3 text-gray-800">
//                   {section.heading}
//                 </h2>
//               )}

//               {section.paragraphs && (
//                 <div className="space-y-4 text-gray-800 leading-relaxed">
//                   {section.paragraphs.map((para, idx) => (
//                     <p key={idx}>{para}</p>
//                   ))}
//                 </div>
//               )}

//               {section.bulletPoints && (
//                 <ul className="list-disc list-inside space-y-2 text-gray-800 mt-4">
//                   {section.bulletPoints.map((item, i) => (
//                     <li key={i}>{item}</li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           ))}
//         </main>

//         {/* Sağ Yan: SSS ve rozetler */}
//         <div className="hidden lg:block w-full">
//           <RightSidebar />
//         </div>
//       </div>

//       <AboutSection />
//       <Footer />
//     </>
//   );
// };

// export default BlogDetail;
import React from "react";
import { useParams } from "react-router-dom";
import blogDataTr from "../data/blog-post.json";
import Footer from "../components/Footer";
import HeroSlider from "../components/HeroSlider";
import AboutSection from "../components/AboutSection";
import LeftSidebar from "../components/Sidebars/LeftSidebar";
import RightSidebar from "../components/Sidebars/RightSidebar";

const BlogDetail = () => {
  const { slug } = useParams();
  const blogData = blogDataTr["blog-post"];
  const post = blogData.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="text-center text-red-500 py-20">
        Blog bulunamadı
      </div>
    );
  }

  return (
    <>
      <HeroSlider />

      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <h1 className="text-3xl font-bold mb-6 text-black">{post.title}</h1>

          {post.sections.map((section, index) => (
            <div key={index} className="mb-10">
              {section.heading && (
                <h2 className="text-2xl font-semibold mb-3 text-gray-800">
                  {section.heading}
                </h2>
              )}

              {section.paragraphs && (
                <div className="space-y-4 text-gray-800 leading-relaxed">
                  {section.paragraphs.map((para, idx) => (
                    <p key={idx}>{para}</p>
                  ))}
                </div>
              )}

              {section.bulletPoints && (
                <ul className="list-disc list-inside space-y-2 text-gray-800 mt-4">
                  {section.bulletPoints.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          {/* Mobilde sola düşen sidebar buraya gelir */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar - tüm ekranlarda görünür */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>

      <AboutSection />
      <Footer />
    </>
  );
};

export default BlogDetail;
